import { createSlice } from "@reduxjs/toolkit";

const initialState = {

    //get win rate
    winRate:[],
    getWinRateLoading: false,
    getWinRateSuccess: false,
    getWinRateError: null,

    //lots traded 
    lotsTraded:[],
    getLotsTradedLoading: false,
    getLotsTradedSuccess: false,
    getLotsTradedError: null,

    //profitableTime
    profitableTime:[],
    getProfitableTimeLoading: false,
    getProfitableTimeSuccess: false,
    getProfitableTimeError: null,

    //get statistics
    getStatisticsLoading: false,
    getStatisticsSuccess: false,
    getStatisticsError: null,
    statistics: [],
}


const ChallengePerformanceReducer = createSlice({
    name: "Challenge Performance",
    initialState,
    reducers: {

        //get win rate
        getWinRateRequest: (state) => {
            state.getWinRateLoading = true;
            state.getWinRateSuccess = false;
            state.getWinRateError = null;
            state.winRate = [];
        },
        getWinRateSuccess: (state, { payload }) => {
            state.winRate = payload;
            state.getWinRateLoading = false;
            state.getWinRateSuccess = true;
            state.getWinRateError = null;
        },
        getWinRateError: (state, { payload }) => {
            state.getWinRateLoading = false;
            state.getWinRateSuccess = false;
            state.getWinRateError = payload;
        },

        //get lots traded
        getLotsTradedRequest: (state) => {
            state.getLotsTradedLoading = true;
            state.getLotsTradedSuccess = false;
            state.getLotsTradedError = null;
            state.lotsTraded = [];
        },
        getLotsTradedSuccess: (state, { payload }) => {
            state.lotsTraded = payload;
            state.getLotsTradedLoading = false;
            state.getLotsTradedSuccess = true;
            state.getLotsTradedError = null;
        },
        getLotsTradedError: (state, { payload }) => {
            state.getLotsTradedLoading = false;
            state.getLotsTradedSuccess = false;
            state.getLotsTradedError = payload;
        },

        //get profitable time
        getProfitableTimeRequest: (state) => {
            state.getProfitableTimeLoading = true;
            state.getProfitableTimeSuccess = false;
            state.getProfitableTimeError = null;
            state.profitableTime = [];
        },
        getProfitableTimeSuccess: (state, { payload }) => {
            state.profitableTime = payload;
            state.getProfitableTimeLoading = false;
            state.getProfitableTimeSuccess = true;
            state.getProfitableTimeError = null;
        },
        getProfitableTimeError: (state, { payload }) => {
            state.getProfitableTimeLoading = false;
            state.getProfitableTimeSuccess = false;
            state.getProfitableTimeError = payload;
        },

        //get statistics
        getStatisticsRequest: (state) => {
            state.getStatisticsLoading = true;
            state.getStatisticsSuccess = false;
            state.getStatisticsError = null;
            state.statistics = [];
        },
        getStatisticsSuccess: (state, { payload }) => {
            state.statistics = payload;
            state.getStatisticsLoading = false;
            state.getStatisticsSuccess = true;
            state.getStatisticsError = null;
        },
        getStatisticsError: (state, { payload }) => {
            state.getStatisticsLoading = false;
            state.getStatisticsSuccess = false;
            state.getStatisticsError = payload;
        },

        //clear states
        clearStates: (state) => {
    
            
            state.getWinRateSuccess = false;
            state.getWinRateError = null;

            state.getLotsTradedSuccess = false;
            state.getLotsTradedError = null;

            state.getProfitableTimeSuccess = false;
            state.getProfitableTimeError = null;

            state.getStatisticsSuccess = false;
            state.getStatisticsError = null;
        },
    }})

export const ChallengePerformanceActions = ChallengePerformanceReducer.actions;

export default ChallengePerformanceReducer.reducer;
